import type { ComponentProps, FC } from 'react';
import { ActionableNotification, FeatureFlags } from '@carbon/react';

// O AVISO COM AÇÃO DA PÁGINA (a `ActionableNotification` do Carbon), do jeito certo para morar no
// fluxo da página, e não como diálogo:
// - `role='status'`: com o padrão (`alertdialog`), o Carbon prende o Tab dentro do aviso, e quem
//   usa o teclado não chega às abas nem à tabela;
// - sem roubar o foco ao aparecer (`hasFocus={false}`);
// - sem as duas "Focus sentinel" (em inglês) que o Carbon põe em volta enquanto a flag v12
//   `enable-focus-wrap-without-sentinels` está desligada: fora de um diálogo elas viram duas paradas
//   de Tab invisíveis, lidas como "Focus sentinel, link".
// `uiCarbon.test.ts` só deixa a `ActionableNotification` aparecer aqui.

export const AvisoComAcao: FC<ComponentProps<typeof ActionableNotification>> = (props) => (
  <FeatureFlags enableFocusWrapWithoutSentinels>
    <ActionableNotification role='status' hasFocus={false} {...props} />
  </FeatureFlags>
);
